import Vue from "vue"
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from "vuetify/lib"
import EvaIcons from 'vue-eva-icons'
import VueTablerIcons from 'vue-tabler-icons'
import { yzicons } from './yzicons'
import { yzcolors } from './yzcolors'

Vuetify.config.silent = true
Vue.use(EvaIcons)
Vue.use(Vuetify)
Vue.use(VueTablerIcons)

export default new Vuetify({
  treeShake: true,
  theme: {
    dark: false,
    themes: {
      light: {
        ...yzcolors.light
      },
    },
  },
  icons: {
    values: yzicons
  },
})
